import { isRoleGreaterThanOrEqual, MeetingSessionOvenMediaReceiver } from "@kalyzee/kast-web-sdk";
import { UserRole } from "@kalyzee/kast-web-sdk/websocket";
import { useSettings } from "../../hooks/settings";
import { PopulatedMeetingData } from "../../interfaces/populatedData";
import { SessionSoundIndicator } from "../media/SessionSoundIndicator";

export interface DevSoundIndicatorsBannerProps {
  label?: string;
  meetingData?: PopulatedMeetingData;
  canHearSession?: (session: MeetingSessionOvenMediaReceiver) => boolean;
  style?: React.CSSProperties;
  className?: string;
}

export const DevSoundIndicatorsBanner = ({ label, meetingData, canHearSession, style, className }: DevSoundIndicatorsBannerProps) => {
  const [settings] = useSettings();
  if (!settings.soundIndicators) return null;
  if (!meetingData || !canHearSession) return null;

  const nodes: React.ReactNode[] = [];
  meetingData?.users.forEach((user) => {
    user.sessions.forEach((session) => {
      session.videoSessions.forEach((videoSession) => {
        if (!canHearSession(videoSession)) return;
        const isPeda = session.session.extra?.isPedagogy;
        const isExpert = !isPeda && isRoleGreaterThanOrEqual(user.user.role, UserRole.ORGANIZER);
        nodes.push(
          <SessionSoundIndicator
            key={`video-session-indicator-${videoSession.getId()}`}
            userName={`${user.user.firstname} ${user.user.lastname}`}
            session={videoSession}
            label={label}
            isExpert={isExpert}
            isPeda={isPeda}
            style={style}
            className={className}
          />
        );
      });
    });
  });

  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        zIndex: 1000,
        gap: "0.25em",
      }}
    >
      {nodes}
    </div>
  );
};
